<template>
    <el-dialog class="dialog" :visible="dialogs.softSkills" customClass="dialog_main" :append-to-body="true" :close-on-click-modal="false" @close="closeDialog()" @open="handleOpen">
        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog__head-inner">
                <h3 class="dialog__title">Soft Skills</h3>
            </div>
        </div>

        <div slot="default" class="dialog__inner">
            <div class="dialog__content">
                <form action="#" class="search-form" @submit.prevent="search">
                    <div class="search-form__inner">
                        <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': searchValue && searchValue.length !== 0 }" placeholder="Поиск" v-model.trim="searchValue">

                        <button v-if="searchValue && searchValue.length !== 0" class="search-form__reset" @click="searchValue = ''">
                            <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                        </button>

                        <button type="submit" class="search-form__submit">
                            <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                        </button>
                    </div>
                </form>

                <transition name="fade">
                    <div class="dialog__section" v-if="createEntity">
                        <h3>Заполните новый Soft Skill</h3>

                        <form class="entity-form" @submit.prevent="createItem">
                            <div class="entity-form__inner">
                                <div class="entity-form__item">
                                    <el-checkbox v-model="checkedEntity" />
                                </div>
                                <div class="entity-form__item entity-form__item_name">
                                    <validate-input v-model="newSoftSkillName" v-bind:error="newSoftSkillNameError" v-on:update:error="newSoftSkillNameError = $event" type="text" name="name" placeholder="Название" :validateOptions="['empty']" />
                                </div>
                                <!-- <div class="entity-form__item entity-form__item_select">
                                    <v-select class="select" placeholder="Уровень компетенции" name="level" label="value" v-model="entityLevel" :clearable="false" :options="entityLevels">
                                        <template #search="{attributes, events}">
                                            <input
                                                class="vs__search"
                                                v-bind="attributes"
                                                v-on="events"
                                                :required="!entityLevel"
                                            />
                                        </template>
                                        <template #no-options="{ search, searching, loading }">
                                            {{ SELECT_NOT_FOUND }}
                                        </template>
                                        <template #open-indicator="{ attributes }">
                                            <span v-bind="attributes">
                                                <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                            </span>
                                        </template>
                                    </v-select>
                                </div> -->
                                <div class="entity-form__item">
                                    <button type="submit" class="btn btn_action" :disabled="!newSoftSkillName">Создать</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </transition>

                <el-table
                    cell-class-name="table__cell"
                    class="table table_second"
                    header-cell-class-name="table__title"
                    :max-height="createEntity ? 250 : 300"
                    ref="table"
                    row-key="id"
                    :data="filteredData"
                    :default-sort="{ prop: 'code', order: 'ascending' }"
                    @sort-change="sortChange"
                >
                    <el-table-column
                            width="24"
                    >
                        <template slot-scope="scope">
                            <div class="table_flex">
                                <el-checkbox @change="handleSelectionChange([scope.row])"/>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Название"
                        prop="name"
                        sortable
                        :min-width="90"
                        :sort-orders="['ascending', 'descending']"
                    >
                    </el-table-column>
                </el-table>

                <h3 class="dialog__title mt-32 mb-16">Выбранные сущности</h3>

                <el-table
                    cell-class-name="table__cell"
                    class="table table_second"
                    header-cell-class-name="table__title"
                    :max-height="createEntity ? 250 : 300"
                    row-key="id"
                    :show-header="false"
                    :data="selection"
                    :default-sort="{ prop: 'code', order: 'ascending' }"
                >
                    <el-table-column
                        width="24"
                    >
                        <template slot-scope="scope">
                            <div class="table_flex">
                                <el-checkbox checked @change="deleteSelectionChange([scope.row])"/>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Название"
                        prop="name"
                        sortable
                        :min-width="90"
                        :sort-orders="['ascending', 'descending']"
                    >
                    </el-table-column>
                </el-table>
            </div>

            <footer slot="footer" class="dialog__footer mt-24">
                <div class="dialog__footer-inner">
                    <div class="dialog__footer-item">
                        <button type="button" class="btn" @click="closeDialog">Отменить</button>
                    </div>
                    <div class="dialog__footer-item">
                        <button type="submit" class="btn btn_action-second" :disabled="createEntity" @click="createEntity = true">
                            Создать новый Soft Skill

                            <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon"><icon-action /></icon-base>
                        </button>
                        <button type="submit" class="btn btn_action" :disabled="selection.length === 0" @click="submitSelected">Добавить выбранные Soft Skills</button>
                    </div>
                </div>
            </footer>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

import constants from '@/constants.js';
import dialog from '@/mixins/dialog';
import ValidateInput from '@/components/ValidateInput'

// import { mergeArrsByKey } from '@/helpers';

export default {
    mixins: [ dialog ],
    props: {
        qualificationId: {
            required: true,
            type: Number
        }
    },
    components: {
        ValidateInput
    },
    data() {
        return {
            checkedEntity: true,
            entityLevel: 1,
            entityLevels: [1, 2, 3, 4, 5, 6, 7, 8, 9],
            newSoftSkillName: '',
            newSoftSkillNameError: false,
        }
    },
    methods: {
        ...mapActions('editor', [
            'LOAD_SOFT_SKILLS',
            'LOAD_SOFT_SKILLS_BY_QUALIFICATION',
            'CREATE_SOFT_SKILL',
            'UPDATE_SOFT_SKILLS',
            'UPDATE_SOFT_SKILLS_BY_QUALIFICATION',
        ]),
        ...mapMutations('editor', ['SET_QUALIFICATIONS', 'GROUP_QUALIFICATIONS']),

        closeDialog() {
            this.newSoftSkillName = ''
            this.newSoftSkillNameError = false
            this.createEntity = false

            this.selection = []

            this.elDialogs.softSkills = false;
        },
        async createItem(e) {
            // Собираем новые значения и отправляем
            const formData = new FormData(e.target);

            const params = {
                // level: this.entityLevel
                level: 0
            };

            for (const pair of formData.entries()) {
                params[pair[0]] = pair[1];
            }

            this.CREATE_SOFT_SKILL(params).then((softSkill) => {
                e.target.reset();

                this.data = [...this.softSkills];

                if (this.checkedEntity) {
                    this.selection.push(softSkill);
                }
            });
        },
        handleSelectionChange(val) {
            this.selection = [...val, ...this.selection];
        },
        deleteSelectionChange(val) {
            this.selection = this.selection.filter(select => !val.find(item => item.id === select.id))
        },
        async handleOpen() {
            await this.LOAD_SOFT_SKILLS();

            const ids = this.softSkillsByQualification.map(el => el.id)

            this.data = [...this.softSkills].filter(el => !ids.includes(el.id));;
        },
        sortChange(v) {
            if (v.column.order === 'ascending') {
                this.data.sort(this.sortListAsc(v.column.property));
            } else if (v.column.order === 'descending') {
                this.data.sort(this.sortListDesc(v.column.property));
            }
        },
        async submitSelected() {
            const ids = [...new Set(this.selection.map((item) => item.id), ...this.softSkillsByQualification.map((item) => item.id))];

            await this.UPDATE_SOFT_SKILLS_BY_QUALIFICATION({
                id: this.qualificationId,
                ids
            });
            await this.LOAD_SOFT_SKILLS_BY_QUALIFICATION(this.qualificationId)

            const tempQualifications = JSON.parse(JSON.stringify(this.qualifications))
            await this.SET_QUALIFICATIONS(tempQualifications.map(qualification => qualification.id === this.qualificationId ? Object.assign(qualification, { soft_skills: this.softSkillsByQualification.length }) : qualification))
            this.GROUP_QUALIFICATIONS(this.groupItemsBy.name);

            this.closeDialog();
        }
    },
    computed: {
        ...mapState('editor', ['softSkills', 'softSkillsByQualification', 'qualifications', 'groupItemsBy']),
        tableData() {
            // Фильтруем по поиску
            return !this.searchValue ? this.data : this.data.filter((item) => item.name.toLowerCase().includes(this.searchValue.toLowerCase()));
        },

        filteredData() {
            return this.tableData.filter(el => !this.selection.find(select => select.id === el.id))
        }
    },
    created() {
        this.SELECT_NOT_FOUND = constants.SELECT_NOT_FOUND;
    }
}
</script>
